import axios from "axios";
import ruleLiquidation from "../../models/reglasDeLiquidacion/ruleLiquidation";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getRulesLiquidations() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/reglasliqm`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return ruleLiquidation.fromJson(item);
        });
      });
  }
  getRulesLiquidationId(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/reglasliqm/${id}`, { headers })
      .then(({ data }) => data);
  }
  add(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
      descrip: data.description,
      conceptoId: Number(data.conceptId),
      csCostoId: Number(data.csCostId),
      umbral: data.umbral
    };

    return axios
      .post(`${url}/reglasliqm`, payload, { headers })
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
      descrip: data.description,
      conceptoId: Number(data.conceptId),
      csCostoId: Number(data.csCostId),
      umbral: data.umbral
    };

    return axios
      .patch(`${url}/reglasliqm/${data.reglaliqid}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  delete(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/reglasliqm/${id}`, { headers });
  }


  addRuleDistribution(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      reglaLiqId: Number(data.reglaLiqId),
      conceptoId: Number(data.conceptId),
      csCostoId: Number(data.csCostId),
      maximo: data.maximo,
      resto:data.resto
    };

    return axios
      .post(`${url}/reglasliqd`, payload, { headers })
  }

  editRuleDistribution(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {};
    
    if (data.hasOwnProperty('num')) {
        payload.num = data.num;
    }
    
    if (data.hasOwnProperty('maximo')) {
        payload.maximo = data.maximo;
    }
    
    if (data.hasOwnProperty('resto') && typeof data.resto === 'boolean') {
        payload.resto = data.resto;
    }
    return axios
      .patch(`${url}/reglasliqd/${data.reglaliqid}&${data.oldItems.orden}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteRuleDistribution(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/reglasliqd/${data.reglaliqid}&${data.orden}`, { headers });
  }

}
export default service;
